export const DIFFERIMENT_TABLE_TITLE = 'Habitat 99 | Diferimiento | Resumen';
